import React from "react";
import PropTypes from "prop-types";
import { LuX, LuAlertCircle } from "react-icons/lu";
import { useTranslation } from "react-i18next";
const ConfirmationModal = ({
  isOpen,
  title,
  description,
  recordName,
  onConfirm,
  onCancel,
  confirmButtonText,
}) => {
  if (!isOpen) return null;
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-4">
        <div className="flex justify-between items-center border-b pb-2">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700"
            onClick={onCancel}
          >
            <LuX size={24} />
          </button>
        </div>
        <div className="mt-4 flex items-center">
          <LuAlertCircle size={48} className="text-yellow-500 mr-4" />
          <div>
            <p className="text-sm text-gray-600">{description}</p>
          </div>
        </div>
        <div className="mt-6 flex justify-end space-x-2">
          <button
            type="button"
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
            onClick={onCancel}
          >
            {t("confirmDeleteModal.cancel") || "Cancel"}
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
            onClick={onConfirm}
          >
            {confirmButtonText || t("confirmDeleteModal.delete") || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  recordName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  strings: PropTypes.object.isRequired,
  confirmButtonText: PropTypes.string,
};

export default ConfirmationModal;
